import { patientApi } from "./patientApi";
import { TAG } from "../constants";
import { Coupon, PatientCouponWithInfo } from "../types";

export const patientCouponsApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    getPatientCoupons: builder.query<
      Pick<Coupon, "amount" | "name">[],
      { product_slug?: string; redeemed?: boolean }
    >({
      query: (params) => ({
        url: `/api/patient/coupons`,
        method: "GET",
        params,
      }),
      providesTags: [TAG.PATIENT_COUPONS],
    }),
    getPatientCoupon: builder.query<PatientCouponWithInfo, string>({
      query: (name) => ({
        method: "GET",
        url: `/api/patient/coupons/${name}`,
      }),
      providesTags: [TAG.PATIENT_COUPONS],
    }),
  }),
});

export const { useGetPatientCouponsQuery, useGetPatientCouponQuery } =
  patientCouponsApi;
